import { createFileRoute } from "@tanstack/react-router";

import UserSettingsPage from "~/pages/user/UserSettingsPage.tsx";

export const Route = createFileRoute("/_auth/dashboard/user-settings/")({
    component: UserSettingsPage,
});
